import React, {useEffect, useState} from 'react'
import {useStore} from 'react-hookstore'
import {textStrings} from './textStrings'

export default function MenuItem(props) {
  const [, setModal] = useStore('modal')
  const [lang] = useStore('language')
  const label=props.children.props.children
  const [txt, setTxt] = useState(null)

  const openModal = () => {
    setModal(modal => ({...modal, label:label,
                        open:'modal-open',
                        title:txt}))
    document.body.style.overflow = 'hidden'
  }

  useEffect(() => setTxt(textStrings[label][lang]),[label,lang])
  useEffect(() => {
    setModal(modal => ({...modal,
                        open:'modal-close',
                        label:label,
                        title:txt
    }))
  },[label, txt])

  return(
    <div className='menuitem' onClick={openModal}>
      {txt}
    </div>
  )
}
